module.exports = __webpack_public_path__ + "static/media/Home-Page-Background.5b34d51c.jpg";